import * as Yup from 'yup';

export const LookupPriceSchema = Yup.object().shape({
  amount: Yup.string()
    .min(1, 'Price is required')
    .required('Price is required'),
});

export type LookupPriceDataType = Yup.InferType<typeof LookupPriceSchema>;

type InitialValues = {
  amount: string;
};

export const LookupPriceInitialValues: InitialValues = {
  amount: '',
};

export interface LookupPriceInterface {
  amount: string;
}
